// nuolino-admin/src/lib/cn.ts
// Helper clsx + tailwind-merge para composição segura de classes.
// Single source of truth — usado por TODOS os componentes.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
